function HttpConfiguratorRun(
  $httpConfigurator
){
  'ngInject';
  $httpConfigurator.setDefaultsHeaders();
}

export default HttpConfiguratorRun;


/** WEBPACK FOOTER **
 ** ./frontend/bootstrap/http.run.js
 **/